// material-ui
import { Typography } from "@mui/material";

// project imports
import NavGroup from "./NavGroup";
import menuItem from "../../../../menu-items/admin";

// ==============================|| SIDEBAR MENU LIST ||============================== //

const userRolePermissions = {
  center_admin: [
    "default",
    "test-types",
    "packages",
    "enquiries",
    "demos",
    "students",
    "attendance",
    "tasks",
    "admin-area",
    "import",
    "expense",
    "accounts",
    "paid-accounts",
    "lesson-plan",
    "classes",
    "reports",
    "raiseticket",
    "campaign",
    "discount",
    "payments",
    "approvecashdeposits",
    "approveupiqrdeposits",
    "approveonlinepayments",
    "approveMiscellaneouspayments",
    "futureenrolments",
    "requestcallbacks",
    "studentleaverequests",
    "eventzone",
    "revenuereports",
    "meeting",
    "classsearch",
    "work-report",
    "employeetarget",
    "advisor-target-report",
    "test-type-advisor-revenue",
    "advisor-task-revenue-report",
    "advisor-leave-request",
    "missedleads",
    "metaReport",
    'auto_assign_leads',
    "website-wise-enquiries",
    "assignment-section",
    "lesson-plan-report",
    "employees-profile",
  ],
  admin: [
    "default",
    "test-types",
    "enquiries",
    "tasks",
    "demos",
    "students",
    "attendance",
    "admin-area",
    "expense",
    "accounts",
    "raiseticket",
    "classes",
    "reports",
    "lesson-plan",
    "campaign",
    "discount",
    "packages",
    "payments",
    "futureenrolments",
    "requestcallbacks",
    "studentleaverequests",
    "meeting",
    "trainer-leave-request",
    "classsearch",
    "work-report",
    "walkin-qr",
    "eventzone",
    "advisor-leave-request",
  ],
  trainer: [
    "default",
    "demos",
    "students",
    "tasks",
    "attendance",
    "lesson-plan",
    "classes",
    "raiseticket",
    "enquiries",
    "discount",
    "packages",
    "payments",
    "futureenrolments",
    "requestcallbacks",
    "studentleaverequests",
    "reports",
    "meeting",
    "trainer-leave-request",
    "work-report",
    "eventzone",
    "lesson-planner",
      "assignment-section",
  ],
  advisor: [
    "default",
    "enquiries",
    "demos",
    "tasks",
    "students",
    "raiseticket",
    "discount",
    "packages",
    "payments",
    "eventzone",
    "futureenrolments",
    "requestcallbacks",
    "reports",
    "classsearch",
    "meeting",
    "work-report",
    "walkin-qr",
    "advisor-leave-request",
  ],
  data_entry: [
    "default",
    "enquiries",
    "import",
    "tasks",
    "raiseticket",
    "campaign",
    "importedleads",
    "eventzone",
    "reports",
    "recyclerequets",
    "addtemplate",
    "meeting",
    "work-report",
    "employees-profile",
    "walkin-qr",
    "advisor-leave-request",
    "missedleads",
    "metaReport",
    "auto_assign_leads",
    "sap_timeline",
    "website-wise-enquiries",
  ],
  accountant: [
    "default",
    "accounts",
    "paid-accounts",
    "expense",
    "raiseticket",
    "approvecashdeposits",
    "approveupiqrdeposits",
    "approveonlinepayments",
    "approveMiscellaneouspayments",
    "meeting",
    "work-report",
    "pendingpayments",
  ],
  developer: [
    "default",
    "test-types",
    "packages",
    "enquiries",
    "demos",
    "students",
    "attendance",
    "tasks",
    "admin-area",
    "import",
    "expense",
    "accounts",
    "viewticket",
    "lesson-plan",
    "classes",
    "reports",
    "campaign",
    "discount",
    "payments",
    "approvecashdeposits",
    "approveupiqrdeposits",
    "approveonlinepayments",
    "futureenrolments",
    "requestcallbacks",
    "studentleaverequests",
    "eventzone",
    "revenuereports",
    "meeting",
    "classsearch",
    "work-report",
  ],
  junior_data_entry: [
    "default",
    "enquiries",
    "import",
    "tasks",
    "raiseticket",
    "campaign",
    "importedleads",
    "eventzone",
    "addtemplate",
    "meeting",
    "missedleads",
    "metaReport",
  ],
  team_lead: [
    "default",
    "enquiries",
    "demos",
    "tasks",
    "students",
    "raiseticket",
    "discount",
    "packages",
    "payments",
    "eventzone",
    "futureenrolments",
    "requestcallbacks",
    "reports",
    "classsearch",
    "meeting",
    "work-report",
    "walkin-qr",
    "advisor-leave-request",
    "team-report",
  ],
};

const MenuList = ({ userRole }) => {
  const filteredItems = menuItem.items.map((groupItem) => {
    if (groupItem.type === "group" && groupItem.children) {
      // Filter children based on user role permissions
      const filteredChildren = groupItem.children.filter((childItem) =>
        userRolePermissions[userRole]?.includes(childItem.id),
      );

      return {
        ...groupItem,
        children: filteredChildren,
      };
    }
    return groupItem;
  });

  const navItems = filteredItems.map((item) => {
    switch (item.type) {
      case "group":
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default MenuList;
